(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = e || self).cssScrollSnapPolyfill = t();
}(void 0, function () {
  "use strict";

  !function (e, t, n) {
    function r(e) {
      return e.replace(/^\s+|\s+$/g, "");
    }

    function o(e, t) {
      var n,
          r = 0;
      if (!e || !t) return !1;

      for (; n = t[r++];) {
        if (e === n) return !0;
      }

      return !1;
    }

    function i(e) {
      var t,
          n = 0;

      for (this._rules = []; t = e[n++];) {
        this._rules.push(new s(t));
      }
    }

    function s(e) {
      this._rule = e;
    }

    function a(e) {
      return this instanceof a ? (this._options = e, e.keywords || (this._options = {
        keywords: e
      }), this._promise = [], this._getStylesheets(), this._downloadStylesheets(), this._parseStylesheets(), this._filterCSSByKeywords(), this._buildMediaQueryMap(), this._reportInitialMatches(), void this._addMediaListeners()) : new a(e);
    }

    var l = RegExp("^" + String({}.valueOf).replace(/[.*+?\^${}()|\[\]\\]/g, "\\$&").replace(/valueOf|for [^\]]+/g, ".+?") + "$"),
        c = function () {
      var e = t.getElementsByTagName("base")[0],
          n = /^([a-zA-Z:]*\/\/)/;
      return function (t) {
        return !n.test(t) && !e || t.replace(RegExp.$1, "").split("/")[0] === location.host;
      };
    }(),
        u = {
      matchMedia: e.matchMedia && e.matchMedia("only all").matches,
      nativeMatchMedia: function (e) {
        return l.test(e);
      }(e.matchMedia)
    },
        f = function () {
      function t() {
        var e;
        0 !== c.readyState && 4 !== c.readyState || ((e = s[0]) && function (e) {
          l++, c.open("GET", e, !0), c.onreadystatechange = function () {
            4 != c.readyState || 200 != c.status && 304 != c.status || (i[e] = c.responseText, s.shift(), t());
          }, c.send(null);
        }(e), e || n());
      }

      function n() {
        for (var e; e = a.shift();) {
          r(e.urls, e.fn);
        }
      }

      function r(e, t) {
        for (var n, r = [], o = 0; n = e[o++];) {
          r.push(i[n]);
        }

        t.call(null, r);
      }

      var i = {},
          s = [],
          a = [],
          l = 0,
          c = function () {
        var t;

        try {
          t = new e.XMLHttpRequest();
        } catch (n) {
          t = new e.ActiveXObject("Microsoft.XMLHTTP");
        }

        return t;
      }();

      return {
        request: function request(e, r) {
          a.push({
            urls: e,
            fn: r
          }), function (e) {
            for (var t, n = 0, r = 0; t = e[n++];) {
              i[t] && r++;
            }

            return r === e.length;
          }(e) ? n() : (function (e) {
            for (var t, n = 0; t = e[n++];) {
              i[t] || o(t, s) || s.push(t);
            }
          }(e), t());
        },
        clearCache: function clearCache() {
          i = {};
        },
        _getRequestCount: function _getRequestCount() {
          return l;
        }
      };
    }(),
        d = {
      _cache: {},
      clearCache: function clearCache() {
        d._cache = {};
      },
      parse: function parse(e, t) {
        function n() {
          return s(/^\{\s*/);
        }

        function o() {
          return s(/^\}\s*/);
        }

        function i() {
          var t,
              n = [];

          for (a(), l(n); "}" != e.charAt(0) && (t = function () {
            if (t = s(/^@([\-\w]+)?keyframes */)) {
              var e = t[1],
                  t = s(/^([\-\w]+)\s*/);

              if (t) {
                var r = t[1];

                if (n()) {
                  l();

                  for (var i, a = []; i = h();) {
                    a.push(i), l();
                  }

                  if (o()) {
                    var c = {
                      name: r,
                      keyframes: a
                    };
                    return e && (c.vendor = e), c;
                  }
                }
              }
            }
          }() || function () {
            var e = s(/^@media *([^{]+)/);

            if (e) {
              var t = r(e[1]);

              if (n()) {
                l();
                var a = i();
                if (o()) return {
                  media: t,
                  rules: a
                };
              }
            }
          }() || function () {
            var e = s(/^@supports *([^{]+)/);

            if (e) {
              var t = r(e[1]);

              if (n()) {
                l();
                var a = i();
                if (o()) return {
                  supports: t,
                  rules: a
                };
              }
            }
          }() || m("import") || m("charset") || m("namespace") || function () {
            if (s(/^@page */)) {
              var e = u() || [],
                  t = [];

              if (n()) {
                l();

                for (var r; r = f() || p();) {
                  t.push(r), l();
                }

                if (o()) return {
                  type: "page",
                  selectors: e,
                  declarations: t
                };
              }
            }
          }() || y());) {
            n.push(t), l(n);
          }

          return n;
        }

        function s(t) {
          var n = t.exec(e);
          if (n) return e = e.slice(n[0].length), n;
        }

        function a() {
          s(/^\s*/);
        }

        function l(e) {
          e = e || [];

          for (var t; t = c();) {
            e.push(t);
          }

          return e;
        }

        function c() {
          if ("/" == e[0] && "*" == e[1]) {
            for (var t = 2; "*" != e[t] || "/" != e[t + 1];) {
              ++t;
            }

            t += 2;
            var n = e.slice(2, t - 2);
            return e = e.slice(t), a(), {
              comment: n
            };
          }
        }

        function u() {
          var e = s(/^([^{]+)/);
          if (e) return r(e[0]).split(/\s*,\s*/);
        }

        function f() {
          var e = s(/^(\*?[\-\w]+)\s*/);

          if (e && (e = e[0], s(/^:\s*/))) {
            var t = s(/^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^\)]*?\)|[^};])+)\s*/);
            if (t) return t = r(t[0]), s(/^[;\s]*/), {
              property: e,
              value: t
            };
          }
        }

        function h() {
          for (var e, t = []; e = s(/^(from|to|\d+%|\.\d+%|\d+\.\d+%)\s*/);) {
            t.push(e[1]), s(/^,\s*/);
          }

          return t.length ? {
            values: t,
            declarations: v()
          } : void 0;
        }

        function p() {
          var e = s(/^@([a-z\-]+) */);
          if (e) return {
            type: e[1],
            declarations: v()
          };
        }

        function m(e) {
          var t = s(new RegExp("^@" + e + " *([^;\\n]+);\\s*"));

          if (t) {
            var n = {};
            return n[e] = r(t[1]), n;
          }
        }

        function v() {
          var e = [];

          if (n()) {
            l();

            for (var t; t = f();) {
              e.push(t), l();
            }

            if (o()) return e;
          }
        }

        function y() {
          var e = u();
          if (e) return l(), {
            selectors: e,
            declarations: v()
          };
        }

        return t && d._cache[t] ? d._cache[t] : (e = e.replace(/\/\*[\s\S]*?\*\//g, ""), d._cache[t] = i());
      },
      filter: function filter(e, t) {
        function n(e, t) {
          return e || t ? e ? e.concat(t) : [t] : void 0;
        }

        function o(e) {
          null == e.media && delete e.media, null == e.supports && delete e.supports, l.push(e);
        }

        function i(e, t) {
          for (var n, o, i, s, a = /\*/, l = 0; n = t[l++];) {
            if (o = n.split(":"), i = new RegExp("^" + r(o[0]).replace(a, ".*") + "$"), s = new RegExp("^" + r(o[1]).replace(a, ".*") + "$"), i.test(e.property) && s.test(e.value)) return !0;
          }
        }

        function s(e, n, r) {
          return t.selectors && function (e, t) {
            if (t) for (var n = t.length; n--;) {
              if (e.indexOf(t[n]) >= 0) return !0;
            }
          }(e.selectors.join(","), t.selectors) ? (o({
            media: n,
            supports: r,
            selectors: e.selectors,
            declarations: e.declarations
          }), !0) : void 0;
        }

        function a(e, n, r) {
          if (t.declarations) for (var s, a = 0; s = e.declarations[a++];) {
            if (i(s, t.declarations)) return o({
              media: n,
              supports: r,
              selectors: e.selectors,
              declarations: e.declarations
            }), !0;
          }
        }

        var l = [];
        return function e(t, r, o) {
          for (var i, l = 0; i = t[l++];) {
            i.declarations ? s(i, r, o) || a(i, r, o) : i.rules && i.media ? e(i.rules, n(r, i.media), o) : i.rules && i.supports && e(i.rules, r, n(o, i.supports));
          }
        }(e), l;
      }
    },
        h = function () {
      function n() {
        if (o) return o;
        var e = t.documentElement,
            n = t.body,
            r = e.style.fontSize,
            i = n.style.fontSize,
            s = t.createElement("div");
        return e.style.fontSize = "1em", n.style.fontSize = "1em", n.appendChild(s), s.style.width = "1em", s.style.position = "absolute", o = s.offsetWidth, n.removeChild(s), n.style.fontSize = i, e.style.fontSize = r, o;
      }

      function r(t) {
        return e.matchMedia(t);
      }

      var o,
          i,
          s = /\(min\-width:[\s]*([\s]*[0-9\.]+)(px|em)[\s]*\)/,
          a = /\(max\-width:[\s]*([\s]*[0-9\.]+)(px|em)[\s]*\)/;
      return {
        matchMedia: function matchMedia(e) {
          return u.matchMedia ? r(e) : function (e) {
            var r,
                o,
                l = !1;
            return i = t.documentElement.clientWidth, s.test(e) && (r = "em" === RegExp.$2 ? parseFloat(RegExp.$1) * n() : parseFloat(RegExp.$1)), a.test(e) && (o = "em" === RegExp.$2 ? parseFloat(RegExp.$1) * n() : parseFloat(RegExp.$1)), r && o ? l = i >= r && o >= i : (r && i >= r && (l = !0), o && o >= i && (l = !0)), {
              matches: l,
              media: e
            };
          }(e);
        },
        clearCache: function clearCache() {
          u.nativeMatchMedia || (i = null, {});
        }
      };
    }(),
        p = function () {
      var t = function () {
        var e = [];
        return {
          add: function add(t, n, r) {
            for (var o, i = 0; o = e[i++];) {
              if (o.polyfill == t && o.mql === n && o.fn === r) return !1;
            }

            n.addListener(r), e.push({
              polyfill: t,
              mql: n,
              fn: r
            });
          },
          remove: function remove(t) {
            for (var n, r = 0; n = e[r++];) {
              n.polyfill === t && (n.mql.removeListener(n.fn), e.splice(--r, 1));
            }
          }
        };
      }(),
          n = function (t) {
        function n() {
          for (var e, n = 0; e = t[n++];) {
            e.fn();
          }
        }

        return {
          add: function add(r, o) {
            t.length || (e.addEventListener ? e.addEventListener("resize", n, !1) : e.attachEvent("onresize", n)), t.push({
              polyfill: r,
              fn: o
            });
          },
          remove: function remove(r) {
            for (var o, i = 0; o = t[i++];) {
              o.polyfill === r && t.splice(--i, 1);
            }

            t.length || (e.removeEventListener ? e.removeEventListener("resize", n, !1) : e.detachEvent && e.detachEvent("onresize", n));
          }
        };
      }([]);

      return {
        removeListeners: function removeListeners(e) {
          u.nativeMatchMedia ? t.remove(e) : n.remove(e);
        },
        addListeners: function addListeners(e, r) {
          function o(e, t) {
            var n,
                o = {};

            for (n in h.clearCache(), t) {
              t.hasOwnProperty(n) && (o[n] = h.matchMedia(n).matches, o[n] != s[n] && r.call(e, n, h.matchMedia(n).matches));
            }

            s = o;
          }

          var i = e._mediaQueryMap,
              s = {};
          !function () {
            for (var e in i) {
              i.hasOwnProperty(e) && (s[e] = h.matchMedia(e).matches);
            }
          }(), function () {
            if (u.nativeMatchMedia) for (var s in i) {
              i.hasOwnProperty(s) && function (n, o) {
                t.add(e, n, function () {
                  r.call(e, o, n.matches);
                });
              }(i[s], s);
            } else {
              var a = function (e, t) {
                var n;
                return function () {
                  clearTimeout(n), n = setTimeout(e, t);
                };
              }(function (e, t) {
                return function () {
                  o(e, t);
                };
              }(e, i), e._options.debounceTimeout || 100);

              n.add(e, a);
            }
          }();
        }
      };
    }();

    i.prototype.each = function (e, t) {
      var n,
          r = 0;

      for (t || (t = this); n = this._rules[r++];) {
        e.call(t, n);
      }
    }, i.prototype.size = function () {
      return this._rules.length;
    }, i.prototype.at = function (e) {
      return this._rules[e];
    }, s.prototype.getDeclaration = function () {
      for (var e, t = {}, n = 0, r = this._rule.declarations; e = r[n++];) {
        t[e.property] = e.value;
      }

      return t;
    }, s.prototype.getSelectors = function () {
      return this._rule.selectors.join(", ");
    }, s.prototype.getMedia = function () {
      return this._rule.media.join(" and ");
    }, a.prototype.doMatched = function (e) {
      return this._doMatched = e, this._resolve(), this;
    }, a.prototype.undoUnmatched = function (e) {
      return this._undoUnmatched = e, this._resolve(), this;
    }, a.prototype.getCurrentMatches = function () {
      for (var e, t, n = 0, r = []; e = this._filteredRules[n++];) {
        (!(t = e.media && e.media.join(" and ")) || h.matchMedia(t).matches) && r.push(e);
      }

      return new i(r);
    }, a.prototype.destroy = function () {
      this._undoUnmatched && (this._undoUnmatched(this.getCurrentMatches()), p.removeListeners(this));
    }, a.prototype._defer = function (e, t) {
      e.call(this) ? t.call(this) : this._promise.push({
        condition: e,
        callback: t
      });
    }, a.prototype._resolve = function () {
      for (var e, t = 0; e = this._promise[t];) {
        e.condition.call(this) ? (this._promise.splice(t, 1), e.callback.call(this)) : t++;
      }
    }, a.prototype._getStylesheets = function () {
      var e,
          n,
          r,
          i,
          s,
          a,
          l,
          u = 0,
          f = [];

      if (this._options.include) {
        for (n = this._options.include; e = n[u++];) {
          if (r = t.getElementById(e)) {
            if ("STYLE" === r.nodeName) {
              l = {
                text: r.textContent
              }, f.push(l);
              continue;
            }

            if (r.media && "print" == r.media) continue;
            if (!c(r.href)) continue;
            l = {
              href: r.href
            }, r.media && (l.media = r.media), f.push(l);
          }
        }
      } else {
        for (n = this._options.exclude, i = t.getElementsByTagName("link"); r = i[u++];) {
          r.rel && "stylesheet" == r.rel && "print" != r.media && c(r.href) && !o(r.id, n) && (l = {
            href: r.href
          }, r.media && (l.media = r.media), f.push(l));
        }

        for (a = t.getElementsByTagName("style"), u = 0; s = a[u++];) {
          l = {
            text: s.textContent
          }, f.push(l);
        }
      }

      return this._stylesheets = f;
    }, a.prototype._downloadStylesheets = function () {
      for (var e, t = this, n = [], r = 0; e = this._stylesheets[r++];) {
        n.push(e.href);
      }

      f.request(n, function (e) {
        for (var n, r = 0; n = e[r];) {
          t._stylesheets[r++].text = n;
        }

        t._resolve();
      });
    }, a.prototype._parseStylesheets = function () {
      this._defer(function () {
        return this._stylesheets && this._stylesheets.length && this._stylesheets[0].text;
      }, function () {
        for (var e, t = 0; e = this._stylesheets[t++];) {
          e.rules = d.parse(e.text, e.url);
        }
      });
    }, a.prototype._filterCSSByKeywords = function () {
      this._defer(function () {
        return this._stylesheets && this._stylesheets.length && this._stylesheets[0].rules;
      }, function () {
        for (var e, t, n = [], r = 0; e = this._stylesheets[r++];) {
          (t = e.media) && "all" != t && "screen" != t ? n.push({
            rules: e.rules,
            media: e.media
          }) : n = n.concat(e.rules);
        }

        this._filteredRules = d.filter(n, this._options.keywords);
      });
    }, a.prototype._buildMediaQueryMap = function () {
      this._defer(function () {
        return this._filteredRules;
      }, function () {
        var e,
            t,
            n = 0;

        for (this._mediaQueryMap = {}; t = this._filteredRules[n++];) {
          t.media && (e = t.media.join(" and "), this._mediaQueryMap[e] = h.matchMedia(e));
        }
      });
    }, a.prototype._reportInitialMatches = function () {
      this._defer(function () {
        return this._filteredRules && this._doMatched;
      }, function () {
        this._doMatched(this.getCurrentMatches());
      });
    }, a.prototype._addMediaListeners = function () {
      this._defer(function () {
        return this._filteredRules && this._doMatched && this._undoUnmatched;
      }, function () {
        p.addListeners(this, function (e, t) {
          for (var n, r = 0, o = [], s = []; n = this._filteredRules[r++];) {
            n.media && n.media.join(" and ") == e && (t ? o : s).push(n);
          }

          o.length && this._doMatched(new i(o)), s.length && this._undoUnmatched(new i(s));
        });
      });
    }, a.modules = {
      DownloadManager: f,
      StyleManager: d,
      MediaManager: h,
      EventManager: p
    }, a.constructors = {
      Ruleset: i,
      Rule: s
    }, e.Polyfill = a;
  }(window, document);
  var e = "none",
      t = "start",
      n = "end",
      r = "center",
      o = /(\d+)(px|vh|vw|%)/g,
      i = .18,
      s = 350;

  function a(t) {
    t.each(function (t) {
      var n = document.querySelectorAll(t.getSelectors()),
          r = t.getDeclaration();
      [].forEach.call(n, function (t) {
        !function (t, n) {
          if (void 0 !== n["scroll-snap-align"]) return t.scrollSnapAlignment = function (t) {
            var n = t["scroll-snap-align"];
            var r = e,
                o = e;

            if (void 0 !== n) {
              var _e = n.split(" ");

              r = _e[0], o = _e.length > 1 ? _e[1] : r;
            }

            return {
              x: r,
              y: o
            };
          }(n), function (e) {
            for (var t = e; e && e !== document; e = e.parentNode) {
              void 0 !== e.snapElements && e.snapElements.push(t);
            }
          }(t);
          var r = t.tagName;
          "body" != r.toLowerCase() && "html" != r.toLowerCase() || (t = document);
          t.addEventListener("scroll", p, !1), t.scrollPadding = function (e) {
            var t = e["scroll-padding"],
                n = e["scroll-padding-top"],
                r = e["scroll-padding-right"],
                o = e["scroll-padding-bottom"],
                i = e["scroll-padding-left"];
            var s = {
              value: 0,
              unit: "px"
            },
                a = {
              value: 0,
              unit: "px"
            },
                l = {
              value: 0,
              unit: "px"
            },
                u = {
              value: 0,
              unit: "px"
            };

            if (void 0 !== t) {
              var _e2 = t.split(" ");

              _e2.forEach(function (e, t) {
                var n = c(e);

                switch (t) {
                  case 0:
                    s = n, a = n, l = n, u = n;
                    break;

                  case 1:
                    a = n, u = n;
                    break;

                  case 2:
                    l = n;
                    break;

                  case 3:
                    u = n;
                }
              });
            }

            void 0 !== n && (s = c(n));
            void 0 !== r && (a = c(r));
            void 0 !== o && (l = c(o));
            void 0 !== i && (u = c(i));
            return {
              top: s,
              right: a,
              bottom: l,
              left: u
            };
          }(n), t.snapElements = [];
        }(t, r);
      });
    });
  }

  function l(e) {
    e.each(function (e) {
      var t = document.querySelectorAll(e.getSelectors());
      [].forEach.call(t, function (e) {
        !function (e) {
          var t = e.tagName;
          "body" != t.toLowerCase() && "html" != t.toLowerCase() || (e = document);
          document.removeEventListener("scroll", p, !1), e.removeEventListener("scroll", p, !1), e.snapLengthUnit = null, e.snapElements = [];
        }(e);
      });
    });
  }

  function c(e) {
    var t = o.exec(e);
    if (null === t) return {
      value: 0,
      unit: "px"
    };

    var _t = _slicedToArray(t, 3),
        n = _t[0],
        r = _t[1],
        i = _t[2];

    return {
      value: parseInt(r, 10),
      unit: i
    };
  }

  var u,
      f,
      d = null,
      h = null,
      p = function p(e) {
    u = e.target, f = function (e) {
      if (e == document || e == window) return document.documentElement.scrollTop > 0 || document.documentElement.scrollLeft > 0 ? document.documentElement : document.querySelector("body");
      return e;
    }(u), N && (cancelAnimationFrame(N) || clearTimeout(N)), d ? clearTimeout(d) : h = {
      y: f.scrollTop,
      x: f.scrollLeft
    }, d = setTimeout(m, 45);
  },
      m = function m() {
    if (h.y == f.scrollTop && h.x == f.scrollLeft) return;
    var e,
        t = {
      y: h.y - f.scrollTop > 0 ? -1 : 1,
      x: h.x - f.scrollLeft > 0 ? -1 : 1
    };
    void 0 !== f.snapElements && f.snapElements.length > 0 && (e = function (e, t, n) {
      var r = t.snapElements.length,
          o = e.scrollTop,
          s = e.scrollLeft,
          a = Math.min(n.y, n.x),
          l = {
        y: 0,
        x: 0
      };

      var _e$scrollPadding = e.scrollPadding,
          c = _e$scrollPadding.top,
          u = _e$scrollPadding.right,
          f = _e$scrollPadding.bottom,
          d = _e$scrollPadding.left,
          h = _(n, g(c.value, c.unit, e)),
          p = (_(n, g(u.value, u.unit, e)), _(n, g(f.value, f.unit, e)), _(n, g(d.value, d.unit, e)));

      function m(e, t) {
        return 0 === y || y === r - 1 ? e : e - t;
      }

      if (s > 0 && s + C(e) === S(e) || o > 0 && o + L(e) === w(e)) {
        y = r - 1;
        var _o = t.snapElements[y],
            _i2 = {
          x: R(_o) - R(e) + E(_o, _o.scrollSnapAlignment.x, n),
          y: T(_o) - T(e) + M(_o, _o.scrollSnapAlignment.y, n)
        };
        return _o.snapCoords = _i2, {
          y: x(0, w(e), _i2.y),
          x: x(0, S(e), _i2.x)
        };
      }

      var A = t.snapElements[y],
          b = {
        x: 0 === y ? 0 : R(A) - R(e) + E(A, A.scrollSnapAlignment.x, n) - E(e, A.scrollSnapAlignment.x, n),
        y: 0 === y ? 0 : T(A) - T(e) + M(A, A.scrollSnapAlignment.y, n) - M(e, A.scrollSnapAlignment.y, n)
      };
      A.snapCoords = b;
      var N = b.x + n.x * C(A) * i,
          z = b.y + n.y * L(A) * i;

      for (var k = y + a; k < r && k >= 0 && (v = t.snapElements[k], l = {
        y: 0 === k ? 0 : T(v) - T(e) + M(v, v.scrollSnapAlignment.y, n) - M(e, v.scrollSnapAlignment.y, n),
        x: 0 === k ? 0 : R(v) - R(e) + E(v, v.scrollSnapAlignment.x, n) - E(e, v.scrollSnapAlignment.x, n)
      }, v.snapCoords = l, !(1 === n.x ? s < N : s > N) || !(1 === n.y ? o < z : o > z)); k += a) {
        var _t2 = l.x + n.x * C(v) * i,
            _r = l.y + n.y * L(v) * i;

        if (!(1 === n.x ? s > _t2 : s < _t2) && !(1 === n.y ? o > _r : o < _r)) return y = k, {
          y: x(0, w(e), m(l.y, h)),
          x: x(0, S(e), m(l.x, p))
        };
      }

      if (1 == a && k === r - 1) return y = r - 1, {
        y: x(0, w(e), l.y),
        x: x(0, S(e), l.x)
      };
      if (-1 == a && 0 === k) return y = 0, {
        y: x(0, w(e), l.y),
        x: x(0, S(e), l.x)
      };
      return {
        y: x(0, w(e), m(t.snapElements[y].snapCoords.y, h)),
        x: x(0, S(e), m(t.snapElements[y].snapCoords.x, p))
      };
    }(f, u, t)), u.removeEventListener("scroll", p, !1), z(f, e, function () {
      u.addEventListener("scroll", p, !1);
    }), isNaN(e.x) && isNaN(e.y) || (h = e);
  };

  var v = null,
      y = 0;

  function g(e, t, n) {
    return t && "vw" === t.toLowerCase() ? C(document.documentElement) * (e / 100) : t && "vh" === t.toLowerCase() ? L(document.documentElement) * (e / 100) : t && "%" === t ? C(n) * (e / 100) : e;
  }

  function _(e, t) {
    return -1 === e ? Math.floor(t) : Math.ceil(t);
  }

  function x(e, t, n) {
    return Math.max(Math.min(n, t), e);
  }

  function M(e, o, i) {
    return o === t ? 0 : o === n ? L(e) : o === r ? _(i, L(e) / 2) : 0;
  }

  function E(e, o, i) {
    return o === t ? 0 : o === n ? C(e) : o === r ? _(i, C(e) / 2) : 0;
  }

  function w(e) {
    return e.scrollHeight;
  }

  function S(e) {
    return e.scrollWidth;
  }

  function L(e) {
    return e.offsetHeight;
  }

  function C(e) {
    return e.offsetWidth;
  }

  function R(e) {
    return e.offsetLeft + e.clientLeft;
  }

  function T(e) {
    return e.offsetTop + e.clientTop;
  }

  function A(e, t) {
    var n = Math.abs(e - t),
        r = 100 / Math.max(document.documentElement.clientHeight, window.innerHeight || 1) * n,
        o = 100 / s * r;
    return isNaN(o) ? 0 : Math.max(s / 1.5, Math.min(o, s));
  }

  var b = function b(e, t, n, r) {
    return n > r ? t : e + (t - e) * ((o = n / r) * o * o);
    var o;
  },
      N = null,
      z = function z(e, t, n) {
    var r = {
      y: e.scrollTop,
      x: e.scrollLeft
    },
        o = Date.now(),
        i = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function (e) {
      window.setTimeout(e, 15);
    },
        s = Math.max(A(r.y, t.y), A(r.x, t.x)),
        a = function a() {
      var l = Date.now() - o;
      if (isNaN(t.y) || (e.scrollTop = b(r.y, t.y, l, s)), isNaN(t.x) || (e.scrollLeft = b(r.x, t.x, l, s)), l > s) return "function" == typeof n ? n(t) : void 0;
      N = i(a);
    };

    a();
  };

  return function () {
    "scrollSnapAlign" in document.documentElement.style || "webkitScrollSnapAlign" in document.documentElement.style || "msScrollSnapAlign" in document.documentElement.style || Polyfill({
      declarations: ["scroll-snap-type:*", "scroll-snap-align:*", "scroll-snap-padding:*"]
    }).doMatched(a).undoUnmatched(l);
  };
});

},{}],2:[function(require,module,exports){
"use strict";

var Macy = require("./macy.min.js");

var bxslider = require("./jquery.bxslider.min.js");

var cssScrollSnapPolyfill = require("./css-scroll-snap-polyfill.js");

var vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
jQuery(document).ready(function ($) {
  cssScrollSnapPolyfill();
  $(".section-project-slider .slider").bxSlider({
    pager: false,
    touchEnabled: false,
    nextText: '<span class="icon-arrow-front"></span>',
    prevText: '<span class="icon-arrow-back"></span>'
  });
  $(".slider-section").bxSlider({
    pager: false,
    touchEnabled: false,
    nextText: '<span class="icon-arrow-front"></span>',
    prevText: '<span class="icon-arrow-back"></span>'
  });
  $(".section-news .slider").bxSlider({
    pager: false,
    maxSlides: 4,
    minSlides: 1,
    slideMargin: 50,
    slideWidth: 250,
    touchEnabled: false,
    nextText: '<span class="icon-arrow-front"></span>',
    prevText: '<span class="icon-arrow-back"></span>'
  });

  if (vw >= 600) {
    var macyInstance = Macy({
      container: ".about-grid",
      trueOrder: false,
      waitForImages: false,
      margin: 40,
      columns: 4
    });
  }

  var scrollMore = [];
  $(window).on("scroll", function (event) {
    var flag = false;
    var scrollT = $(window).scrollTop();
    $(".make-logo-white").each(function (index, el) {
      var scrollMin = $(el).offset().top - $("#header-main").height();
      var scrollMax = $(el).offset().top + $(el).height() - $("#header-main").height();

      if (scrollT >= scrollMin && scrollT <= scrollMax) {
        flag = flag || true;
      } else {
        flag = flag || false;
      }
    });

    if (flag) {
      $("#header-main").addClass("black-header");
    } else {
      $("#header-main").removeClass("black-header");
    }
  });
  $(".scroll-down").on("click", function (event) {
    event.preventDefault();
    $("body, html").animate({
      scrollTop: $(".slider-section-wrap").offset().top
    }, 500);
  });

  if ($("body").hasClass("home") && vw >= 600) {
    var move = function move() {
      var scrollTop = window.pageYOffset;

      if (scrollTop <= 10) {
        collection.css("opacity", "");
      }

      if (!flag) {
        var y = Math.ceil(scrollTop / sectionHeight);
        var tmpNode = collection.eq(y);
        var e_total = scrollTop / clientHeight - (y - 1);
        var computedOpacity = 0;
        computedOpacity = 1 === y ? 1 - e_total.toFixed(2) : y < 1 ? 1 : 0;

        if (computedOpacity >= 0.9) {
          computedOpacity = 1;
        }

        if (computedOpacity <= 0.08) {
          computedOpacity = 0;
        }

        console.log("opacity-1", computedOpacity);
        ctx.css("opacity", computedOpacity);
        var x = e_total.toFixed(2);

        if (x >= 0.9) {
          x = 1;
        }

        if (x <= 0.08) {
          x = 0;
        }

        tmpNode.css("opacity", x).nextAll(".home-hero__image").css("opacity", "");
      }

      if (scrollTop + clientHeight >= totalHeight) {
        collection.css("opacity", 1);

        if (!flag) {
          TotalContext.addClass("home-hero--stop");
          collection.last().css("opacity", 1);
          ctx.css("top", (collection.length - 1) * sectionHeight);
          flag = true;
        }
      } else {
        if (flag) {
          TotalContext.removeClass("home-hero--stop");
          ctx.css("top", "");
          flag = false;
        }
      }

      interval = animate(move);
    };

    console.log("Home Scroll Triggered");
    /* Execute this only on the home page */

    var TotalContext = $(".home_hero");
    var interval;
    var animate = window.requestAnimationFrame;
    var collection = $(".hero-image", TotalContext);
    var ctx = $(".hero-image.intro-section", TotalContext);
    var clientHeight = window.innerHeight;
    var totalHeight = TotalContext.outerHeight();
    var sectionHeight = collection.outerHeight();
    var menuIndexTop = TotalContext.offset().top;
    var flag = false;
    /* Add Progressively higher Z-Index for slides. */

    collection.each(function (index, el) {
      $(el).css("z-index", index + 1);
    });
    interval = move();
  }
});

},{"./css-scroll-snap-polyfill.js":1,"./jquery.bxslider.min.js":3,"./macy.min.js":4}],3:[function(require,module,exports){
"use strict";

/**
 * bxSlider v4.2.1d
 * Copyright 2013-2017 Steven Wanderski
 * Written while drinking Belgian ales and listening to jazz
 * Licensed under MIT (http://opensource.org/licenses/MIT)
 */
!function (t) {
  var e = {
    mode: "horizontal",
    slideSelector: "",
    infiniteLoop: !0,
    hideControlOnEnd: !1,
    speed: 500,
    easing: null,
    slideMargin: 0,
    startSlide: 0,
    randomStart: !1,
    captions: !1,
    ticker: !1,
    tickerHover: !1,
    adaptiveHeight: !1,
    adaptiveHeightSpeed: 500,
    video: !1,
    useCSS: !0,
    preloadImages: "visible",
    responsive: !0,
    slideZIndex: 50,
    wrapperClass: "bx-wrapper",
    touchEnabled: !0,
    swipeThreshold: 50,
    oneToOneTouch: !0,
    preventDefaultSwipeX: !0,
    preventDefaultSwipeY: !1,
    ariaLive: !0,
    ariaHidden: !0,
    keyboardEnabled: !1,
    pager: !0,
    pagerType: "full",
    pagerShortSeparator: " / ",
    pagerSelector: null,
    buildPager: null,
    pagerCustom: null,
    controls: !0,
    nextText: "Next",
    prevText: "Prev",
    nextSelector: null,
    prevSelector: null,
    autoControls: !1,
    startText: "Start",
    stopText: "Stop",
    autoControlsCombine: !1,
    autoControlsSelector: null,
    auto: !1,
    pause: 4e3,
    autoStart: !0,
    autoDirection: "next",
    stopAutoOnClick: !1,
    autoHover: !1,
    autoDelay: 0,
    autoSlideForOnePage: !1,
    minSlides: 1,
    maxSlides: 1,
    moveSlides: 0,
    slideWidth: 0,
    shrinkItems: !1,
    onSliderLoad: function onSliderLoad() {
      return !0;
    },
    onSlideBefore: function onSlideBefore() {
      return !0;
    },
    onSlideAfter: function onSlideAfter() {
      return !0;
    },
    onSlideNext: function onSlideNext() {
      return !0;
    },
    onSlidePrev: function onSlidePrev() {
      return !0;
    },
    onSliderResize: function onSliderResize() {
      return !0;
    },
    onAutoChange: function onAutoChange() {
      return !0;
    }
  };

  t.fn.bxSlider = function (n) {
    if (0 === this.length) return this;
    if (this.length > 1) return this.each(function () {
      t(this).bxSlider(n);
    }), this;
    var s = {},
        o = this,
        r = t(window).width(),
        a = t(window).height();

    if (!t(o).data("bxSlider")) {
      var l = function l() {
        t(o).data("bxSlider") || (s.settings = t.extend({}, e, n), s.settings.slideWidth = parseInt(s.settings.slideWidth), s.children = o.children(s.settings.slideSelector), s.children.length < s.settings.minSlides && (s.settings.minSlides = s.children.length), s.children.length < s.settings.maxSlides && (s.settings.maxSlides = s.children.length), s.settings.randomStart && (s.settings.startSlide = Math.floor(Math.random() * s.children.length)), s.active = {
          index: s.settings.startSlide
        }, s.carousel = s.settings.minSlides > 1 || s.settings.maxSlides > 1, s.carousel && (s.settings.preloadImages = "all"), s.minThreshold = s.settings.minSlides * s.settings.slideWidth + (s.settings.minSlides - 1) * s.settings.slideMargin, s.maxThreshold = s.settings.maxSlides * s.settings.slideWidth + (s.settings.maxSlides - 1) * s.settings.slideMargin, s.working = !1, s.controls = {}, s.interval = null, s.animProp = "vertical" === s.settings.mode ? "top" : "left", s.usingCSS = s.settings.useCSS && "fade" !== s.settings.mode && function () {
          for (var t = document.createElement("div"), e = ["WebkitPerspective", "MozPerspective", "OPerspective", "msPerspective"], i = 0; i < e.length; i++) {
            if (void 0 !== t.style[e[i]]) return s.cssPrefix = e[i].replace("Perspective", "").toLowerCase(), s.animProp = "-" + s.cssPrefix + "-transform", !0;
          }

          return !1;
        }(), "vertical" === s.settings.mode && (s.settings.maxSlides = s.settings.minSlides), o.data("origStyle", o.attr("style")), o.children(s.settings.slideSelector).each(function () {
          t(this).data("origStyle", t(this).attr("style"));
        }), d());
      },
          d = function d() {
        var e = s.children.eq(s.settings.startSlide);
        o.wrap('<div class="' + s.settings.wrapperClass + '"><div class="bx-viewport"></div></div>'), s.viewport = o.parent(), s.settings.ariaLive && !s.settings.ticker && s.viewport.attr("aria-live", "polite"), s.loader = t('<div class="bx-loading" />'), s.viewport.prepend(s.loader), o.css({
          width: "horizontal" === s.settings.mode ? 1e3 * s.children.length + 215 + "%" : "auto",
          position: "relative"
        }), s.usingCSS && s.settings.easing ? o.css("-" + s.cssPrefix + "-transition-timing-function", s.settings.easing) : s.settings.easing || (s.settings.easing = "swing"), s.viewport.css({
          width: "100%",
          overflow: "hidden",
          position: "relative"
        }), s.viewport.parent().css({
          maxWidth: u()
        }), s.children.css({
          "float": "horizontal" === s.settings.mode ? "left" : "none",
          listStyle: "none",
          position: "relative"
        }), s.children.css("width", h()), "horizontal" === s.settings.mode && s.settings.slideMargin > 0 && s.children.css("marginRight", s.settings.slideMargin), "vertical" === s.settings.mode && s.settings.slideMargin > 0 && s.children.css("marginBottom", s.settings.slideMargin), "fade" === s.settings.mode && (s.children.css({
          position: "absolute",
          zIndex: 0,
          display: "none"
        }), s.children.eq(s.settings.startSlide).css({
          zIndex: s.settings.slideZIndex,
          display: "block"
        })), s.controls.el = t('<div class="bx-controls" />'), s.settings.captions && k(), s.active.last = s.settings.startSlide === f() - 1, s.settings.video && o.fitVids(), "none" === s.settings.preloadImages ? e = null : ("all" === s.settings.preloadImages || s.settings.ticker) && (e = s.children), s.settings.ticker ? s.settings.pager = !1 : (s.settings.controls && C(), s.settings.auto && s.settings.autoControls && T(), s.settings.pager && b(), (s.settings.controls || s.settings.autoControls || s.settings.pager) && s.viewport.after(s.controls.el)), null === e ? g() : c(e, g);
      },
          c = function c(e, i) {
        var n = e.find('img:not([src=""]), iframe').length,
            s = 0;
        if (0 === n) return void i();
        e.find('img:not([src=""]), iframe').each(function () {
          t(this).one("load error", function () {
            ++s === n && i();
          }).each(function () {
            (this.complete || "" == this.src) && t(this).trigger("load");
          });
        });
      },
          g = function g() {
        if (s.settings.infiniteLoop && "fade" !== s.settings.mode && !s.settings.ticker) {
          var e = "vertical" === s.settings.mode ? s.settings.minSlides : s.settings.maxSlides,
              i = s.children.slice(0, e).clone(!0).addClass("bx-clone"),
              n = s.children.slice(-e).clone(!0).addClass("bx-clone");
          s.settings.ariaHidden && (i.attr("aria-hidden", !0), n.attr("aria-hidden", !0)), o.append(i).prepend(n);
        }

        s.loader.remove(), m(), "vertical" === s.settings.mode && (s.settings.adaptiveHeight = !0), s.viewport.height(p()), o.redrawSlider(), s.settings.onSliderLoad.call(o, s.active.index), s.initialized = !0, s.settings.responsive && t(window).on("resize", U), s.settings.auto && s.settings.autoStart && (f() > 1 || s.settings.autoSlideForOnePage) && L(), s.settings.ticker && O(), s.settings.pager && z(s.settings.startSlide), s.settings.controls && q(), s.settings.touchEnabled && !s.settings.ticker && X(), s.settings.keyboardEnabled && !s.settings.ticker && t(document).keydown(B);
      },
          p = function p() {
        var e = 0,
            n = t();
        if ("vertical" === s.settings.mode || s.settings.adaptiveHeight) {
          if (s.carousel) {
            var o = 1 === s.settings.moveSlides ? s.active.index : s.active.index * x();

            for (n = s.children.eq(o), i = 1; i <= s.settings.maxSlides - 1; i++) {
              n = o + i >= s.children.length ? n.add(s.children.eq(i - 1)) : n.add(s.children.eq(o + i));
            }
          } else n = s.children.eq(s.active.index);
        } else n = s.children;
        return "vertical" === s.settings.mode ? (n.each(function (i) {
          e += t(this).outerHeight();
        }), s.settings.slideMargin > 0 && (e += s.settings.slideMargin * (s.settings.minSlides - 1))) : e = Math.max.apply(Math, n.map(function () {
          return t(this).outerHeight(!1);
        }).get()), "border-box" === s.viewport.css("box-sizing") ? e += parseFloat(s.viewport.css("padding-top")) + parseFloat(s.viewport.css("padding-bottom")) + parseFloat(s.viewport.css("border-top-width")) + parseFloat(s.viewport.css("border-bottom-width")) : "padding-box" === s.viewport.css("box-sizing") && (e += parseFloat(s.viewport.css("padding-top")) + parseFloat(s.viewport.css("padding-bottom"))), e;
      },
          u = function u() {
        var t = "100%";
        return s.settings.slideWidth > 0 && (t = "horizontal" === s.settings.mode ? s.settings.maxSlides * s.settings.slideWidth + (s.settings.maxSlides - 1) * s.settings.slideMargin : s.settings.slideWidth), t;
      },
          h = function h() {
        var t = s.settings.slideWidth,
            e = s.viewport.width();
        if (0 === s.settings.slideWidth || s.settings.slideWidth > e && !s.carousel || "vertical" === s.settings.mode) t = e;else if (s.settings.maxSlides > 1 && "horizontal" === s.settings.mode) {
          if (e > s.maxThreshold) return t;
          e < s.minThreshold ? t = (e - s.settings.slideMargin * (s.settings.minSlides - 1)) / s.settings.minSlides : s.settings.shrinkItems && (t = Math.floor((e + s.settings.slideMargin) / Math.ceil((e + s.settings.slideMargin) / (t + s.settings.slideMargin)) - s.settings.slideMargin));
        }
        return t;
      },
          v = function v() {
        var t = 1,
            e = null;
        return "horizontal" === s.settings.mode && s.settings.slideWidth > 0 ? s.viewport.width() < s.minThreshold ? t = s.settings.minSlides : s.viewport.width() > s.maxThreshold ? t = s.settings.maxSlides : (e = s.children.first().width() + s.settings.slideMargin, t = Math.floor((s.viewport.width() + s.settings.slideMargin) / e) || 1) : "vertical" === s.settings.mode && (t = s.settings.minSlides), t;
      },
          f = function f() {
        var t = 0,
            e = 0,
            i = 0;

        if (s.settings.moveSlides > 0) {
          if (!s.settings.infiniteLoop) {
            for (; e < s.children.length;) {
              ++t, e = i + v(), i += s.settings.moveSlides <= v() ? s.settings.moveSlides : v();
            }

            return i;
          }

          t = Math.ceil(s.children.length / x());
        } else t = Math.ceil(s.children.length / v());

        return t;
      },
          x = function x() {
        return s.settings.moveSlides > 0 && s.settings.moveSlides <= v() ? s.settings.moveSlides : v();
      },
          m = function m() {
        var t, e, i;
        s.children.length > s.settings.maxSlides && s.active.last && !s.settings.infiniteLoop ? "horizontal" === s.settings.mode ? (e = s.children.last(), t = e.position(), S(-(t.left - (s.viewport.width() - e.outerWidth())), "reset", 0)) : "vertical" === s.settings.mode && (i = s.children.length - s.settings.minSlides, t = s.children.eq(i).position(), S(-t.top, "reset", 0)) : (t = s.children.eq(s.active.index * x()).position(), s.active.index === f() - 1 && (s.active.last = !0), void 0 !== t && ("horizontal" === s.settings.mode ? S(-t.left, "reset", 0) : "vertical" === s.settings.mode && S(-t.top, "reset", 0)));
      },
          S = function S(e, i, n, r) {
        var a, l;
        s.usingCSS ? (l = "vertical" === s.settings.mode ? "translate3d(0, " + e + "px, 0)" : "translate3d(" + e + "px, 0, 0)", o.css("-" + s.cssPrefix + "-transition-duration", n / 1e3 + "s"), "slide" === i ? (o.css(s.animProp, l), 0 !== n ? o.on("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd", function (e) {
          t(e.target).is(o) && (o.off("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd"), A());
        }) : A()) : "reset" === i ? o.css(s.animProp, l) : "ticker" === i && (o.css("-" + s.cssPrefix + "-transition-timing-function", "linear"), o.css(s.animProp, l), 0 !== n ? o.on("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd", function (e) {
          t(e.target).is(o) && (o.off("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd"), S(r.resetValue, "reset", 0), F());
        }) : (S(r.resetValue, "reset", 0), F()))) : (a = {}, a[s.animProp] = e, "slide" === i ? o.animate(a, n, s.settings.easing, function () {
          A();
        }) : "reset" === i ? o.css(s.animProp, e) : "ticker" === i && o.animate(a, n, "linear", function () {
          S(r.resetValue, "reset", 0), F();
        }));
      },
          w = function w() {
        for (var e = "", i = "", n = f(), o = 0; o < n; o++) {
          i = "", s.settings.buildPager && t.isFunction(s.settings.buildPager) || s.settings.pagerCustom ? (i = s.settings.buildPager(o), s.pagerEl.addClass("bx-custom-pager")) : (i = o + 1, s.pagerEl.addClass("bx-default-pager")), e += '<div class="bx-pager-item"><a href="" data-slide-index="' + o + '" class="bx-pager-link">' + i + "</a></div>";
        }

        s.pagerEl.html(e);
      },
          b = function b() {
        s.settings.pagerCustom ? s.pagerEl = t(s.settings.pagerCustom) : (s.pagerEl = t('<div class="bx-pager" />'), s.settings.pagerSelector ? t(s.settings.pagerSelector).html(s.pagerEl) : s.controls.el.addClass("bx-has-pager").append(s.pagerEl), w()), s.pagerEl.on("click touchend", "a", I);
      },
          C = function C() {
        s.controls.next = t('<a class="bx-next" href="">' + s.settings.nextText + "</a>"), s.controls.prev = t('<a class="bx-prev" href="">' + s.settings.prevText + "</a>"), s.controls.next.on("click touchend", P), s.controls.prev.on("click touchend", E), s.settings.nextSelector && t(s.settings.nextSelector).append(s.controls.next), s.settings.prevSelector && t(s.settings.prevSelector).append(s.controls.prev), s.settings.nextSelector || s.settings.prevSelector || (s.controls.directionEl = t('<div class="bx-controls-direction" />'), s.controls.directionEl.append(s.controls.prev).append(s.controls.next), s.controls.el.addClass("bx-has-controls-direction").append(s.controls.directionEl));
      },
          T = function T() {
        s.controls.start = t('<div class="bx-controls-auto-item"><a class="bx-start" href="">' + s.settings.startText + "</a></div>"), s.controls.stop = t('<div class="bx-controls-auto-item"><a class="bx-stop" href="">' + s.settings.stopText + "</a></div>"), s.controls.autoEl = t('<div class="bx-controls-auto" />'), s.controls.autoEl.on("click", ".bx-start", M), s.controls.autoEl.on("click", ".bx-stop", y), s.settings.autoControlsCombine ? s.controls.autoEl.append(s.controls.start) : s.controls.autoEl.append(s.controls.start).append(s.controls.stop), s.settings.autoControlsSelector ? t(s.settings.autoControlsSelector).html(s.controls.autoEl) : s.controls.el.addClass("bx-has-controls-auto").append(s.controls.autoEl), D(s.settings.autoStart ? "stop" : "start");
      },
          k = function k() {
        s.children.each(function (e) {
          var i = t(this).find("img:first").attr("title");
          void 0 !== i && ("" + i).length && t(this).append('<div class="bx-caption"><span>' + i + "</span></div>");
        });
      },
          P = function P(t) {
        t.preventDefault(), s.controls.el.hasClass("disabled") || (s.settings.auto && s.settings.stopAutoOnClick && o.stopAuto(), o.goToNextSlide());
      },
          E = function E(t) {
        t.preventDefault(), s.controls.el.hasClass("disabled") || (s.settings.auto && s.settings.stopAutoOnClick && o.stopAuto(), o.goToPrevSlide());
      },
          M = function M(t) {
        o.startAuto(), t.preventDefault();
      },
          y = function y(t) {
        o.stopAuto(), t.preventDefault();
      },
          I = function I(e) {
        var i, n;
        e.preventDefault(), s.controls.el.hasClass("disabled") || (s.settings.auto && s.settings.stopAutoOnClick && o.stopAuto(), i = t(e.currentTarget), void 0 !== i.attr("data-slide-index") && (n = parseInt(i.attr("data-slide-index"))) !== s.active.index && o.goToSlide(n));
      },
          z = function z(e) {
        var i = s.children.length;
        if ("short" === s.settings.pagerType) return s.settings.maxSlides > 1 && (i = Math.ceil(s.children.length / s.settings.maxSlides)), void s.pagerEl.html(e + 1 + s.settings.pagerShortSeparator + i);
        s.pagerEl.find("a").removeClass("active"), s.pagerEl.each(function (i, n) {
          t(n).find("a").eq(e).addClass("active");
        });
      },
          A = function A() {
        if (s.settings.infiniteLoop) {
          var t = "";
          0 === s.active.index ? t = s.children.eq(0).position() : s.active.index === f() - 1 && s.carousel ? t = s.children.eq((f() - 1) * x()).position() : s.active.index === s.children.length - 1 && (t = s.children.eq(s.children.length - 1).position()), t && ("horizontal" === s.settings.mode ? S(-t.left, "reset", 0) : "vertical" === s.settings.mode && S(-t.top, "reset", 0));
        }

        s.working = !1, s.settings.onSlideAfter.call(o, s.children.eq(s.active.index), s.oldIndex, s.active.index);
      },
          D = function D(t) {
        s.settings.autoControlsCombine ? s.controls.autoEl.html(s.controls[t]) : (s.controls.autoEl.find("a").removeClass("active"), s.controls.autoEl.find("a:not(.bx-" + t + ")").addClass("active"));
      },
          q = function q() {
        1 === f() ? (s.controls.prev.addClass("disabled"), s.controls.next.addClass("disabled")) : !s.settings.infiniteLoop && s.settings.hideControlOnEnd && (0 === s.active.index ? (s.controls.prev.addClass("disabled"), s.controls.next.removeClass("disabled")) : s.active.index === f() - 1 ? (s.controls.next.addClass("disabled"), s.controls.prev.removeClass("disabled")) : (s.controls.prev.removeClass("disabled"), s.controls.next.removeClass("disabled")));
      },
          H = function H() {
        o.startAuto();
      },
          W = function W() {
        o.stopAuto();
      },
          L = function L() {
        s.settings.autoDelay > 0 ? setTimeout(o.startAuto, s.settings.autoDelay) : (o.startAuto(), t(window).focus(H).blur(W)), s.settings.autoHover && o.hover(function () {
          s.interval && (o.stopAuto(!0), s.autoPaused = !0);
        }, function () {
          s.autoPaused && (o.startAuto(!0), s.autoPaused = null);
        });
      },
          O = function O() {
        var e,
            i,
            n,
            r,
            a,
            l,
            d,
            c,
            g = 0;
        "next" === s.settings.autoDirection ? o.append(s.children.clone().addClass("bx-clone")) : (o.prepend(s.children.clone().addClass("bx-clone")), e = s.children.first().position(), g = "horizontal" === s.settings.mode ? -e.left : -e.top), S(g, "reset", 0), s.settings.pager = !1, s.settings.controls = !1, s.settings.autoControls = !1, s.settings.tickerHover && (s.usingCSS ? (r = "horizontal" === s.settings.mode ? 4 : 5, s.viewport.hover(function () {
          i = o.css("-" + s.cssPrefix + "-transform"), n = parseFloat(i.split(",")[r]), S(n, "reset", 0);
        }, function () {
          c = 0, s.children.each(function (e) {
            c += "horizontal" === s.settings.mode ? t(this).outerWidth(!0) : t(this).outerHeight(!0);
          }), a = s.settings.speed / c, l = "horizontal" === s.settings.mode ? "left" : "top", d = a * (c - Math.abs(parseInt(n))), F(d);
        })) : s.viewport.hover(function () {
          o.stop();
        }, function () {
          c = 0, s.children.each(function (e) {
            c += "horizontal" === s.settings.mode ? t(this).outerWidth(!0) : t(this).outerHeight(!0);
          }), a = s.settings.speed / c, l = "horizontal" === s.settings.mode ? "left" : "top", d = a * (c - Math.abs(parseInt(o.css(l)))), F(d);
        })), F();
      },
          F = function F(t) {
        var e,
            i,
            n,
            r = t || s.settings.speed,
            a = {
          left: 0,
          top: 0
        },
            l = {
          left: 0,
          top: 0
        };
        "next" === s.settings.autoDirection ? a = o.find(".bx-clone").first().position() : l = s.children.first().position(), e = "horizontal" === s.settings.mode ? -a.left : -a.top, i = "horizontal" === s.settings.mode ? -l.left : -l.top, n = {
          resetValue: i
        }, S(e, "ticker", r, n);
      },
          N = function N(e) {
        var i = t(window),
            n = {
          top: i.scrollTop(),
          left: i.scrollLeft()
        },
            s = e.offset();
        return n.right = n.left + i.width(), n.bottom = n.top + i.height(), s.right = s.left + e.outerWidth(), s.bottom = s.top + e.outerHeight(), !(n.right < s.left || n.left > s.right || n.bottom < s.top || n.top > s.bottom);
      },
          B = function B(t) {
        var e = document.activeElement.tagName.toLowerCase();

        if (null == new RegExp(e, ["i"]).exec("input|textarea") && N(o)) {
          if (39 === t.keyCode) return P(t), !1;
          if (37 === t.keyCode) return E(t), !1;
        }
      },
          X = function X() {
        s.touch = {
          start: {
            x: 0,
            y: 0
          },
          end: {
            x: 0,
            y: 0
          }
        }, s.viewport.on("touchstart MSPointerDown pointerdown", Y), s.viewport.on("click", ".bxslider a", function (t) {
          s.viewport.hasClass("click-disabled") && (t.preventDefault(), s.viewport.removeClass("click-disabled"));
        });
      },
          Y = function Y(t) {
        if ("touchstart" === t.type || 0 === t.button) if (t.preventDefault(), s.controls.el.addClass("disabled"), s.working) s.controls.el.removeClass("disabled");else {
          s.touch.originalPos = o.position();
          var e = t.originalEvent,
              i = void 0 !== e.changedTouches ? e.changedTouches : [e],
              n = "function" == typeof PointerEvent;
          if (n && void 0 === e.pointerId) return;
          s.touch.start.x = i[0].pageX, s.touch.start.y = i[0].pageY, s.viewport.get(0).setPointerCapture && (s.pointerId = e.pointerId, s.viewport.get(0).setPointerCapture(s.pointerId)), s.originalClickTarget = e.originalTarget || e.target, s.originalClickButton = e.button, s.originalClickButtons = e.buttons, s.originalEventType = e.type, s.hasMove = !1, s.viewport.on("touchmove MSPointerMove pointermove", R), s.viewport.on("touchend MSPointerUp pointerup", Z), s.viewport.on("MSPointerCancel pointercancel", V);
        }
      },
          V = function V(t) {
        t.preventDefault(), S(s.touch.originalPos.left, "reset", 0), s.controls.el.removeClass("disabled"), s.viewport.off("MSPointerCancel pointercancel", V), s.viewport.off("touchmove MSPointerMove pointermove", R), s.viewport.off("touchend MSPointerUp pointerup", Z), s.viewport.get(0).releasePointerCapture && s.viewport.get(0).releasePointerCapture(s.pointerId);
      },
          R = function R(t) {
        var e = t.originalEvent,
            i = void 0 !== e.changedTouches ? e.changedTouches : [e],
            n = Math.abs(i[0].pageX - s.touch.start.x),
            o = Math.abs(i[0].pageY - s.touch.start.y),
            r = 0,
            a = 0;
        s.hasMove = !0, 3 * n > o && s.settings.preventDefaultSwipeX ? t.preventDefault() : 3 * o > n && s.settings.preventDefaultSwipeY && t.preventDefault(), "touchmove" !== t.type && t.preventDefault(), "fade" !== s.settings.mode && s.settings.oneToOneTouch && ("horizontal" === s.settings.mode ? (a = i[0].pageX - s.touch.start.x, r = s.touch.originalPos.left + a) : (a = i[0].pageY - s.touch.start.y, r = s.touch.originalPos.top + a), S(r, "reset", 0));
      },
          Z = function Z(e) {
        e.preventDefault(), s.viewport.off("touchmove MSPointerMove pointermove", R), s.controls.el.removeClass("disabled");
        var i = e.originalEvent,
            n = void 0 !== i.changedTouches ? i.changedTouches : [i],
            r = 0,
            a = 0;
        s.touch.end.x = n[0].pageX, s.touch.end.y = n[0].pageY, "fade" === s.settings.mode ? (a = Math.abs(s.touch.start.x - s.touch.end.x)) >= s.settings.swipeThreshold && (s.touch.start.x > s.touch.end.x ? o.goToNextSlide() : o.goToPrevSlide(), o.stopAuto()) : ("horizontal" === s.settings.mode ? (a = s.touch.end.x - s.touch.start.x, r = s.touch.originalPos.left) : (a = s.touch.end.y - s.touch.start.y, r = s.touch.originalPos.top), !s.settings.infiniteLoop && (0 === s.active.index && a > 0 || s.active.last && a < 0) ? S(r, "reset", 200) : Math.abs(a) >= s.settings.swipeThreshold ? (a < 0 ? o.goToNextSlide() : o.goToPrevSlide(), o.stopAuto()) : S(r, "reset", 200)), s.viewport.off("touchend MSPointerUp pointerup", Z), s.viewport.get(0).releasePointerCapture && s.viewport.get(0).releasePointerCapture(s.pointerId), !1 !== s.hasMove || 0 !== s.originalClickButton && "touchstart" !== s.originalEventType || t(s.originalClickTarget).trigger({
          type: "click",
          button: s.originalClickButton,
          buttons: s.originalClickButtons
        });
      },
          U = function U(e) {
        if (s.initialized) if (s.working) window.setTimeout(U, 10);else {
          var i = t(window).width(),
              n = t(window).height();
          r === i && a === n || (r = i, a = n, o.redrawSlider(), s.settings.onSliderResize.call(o, s.active.index));
        }
      },
          j = function j(t) {
        var e = v();
        s.settings.ariaHidden && !s.settings.ticker && (s.children.attr("aria-hidden", "true"), s.children.slice(t, t + e).attr("aria-hidden", "false"));
      },
          Q = function Q(t) {
        return t < 0 ? s.settings.infiniteLoop ? f() - 1 : s.active.index : t >= f() ? s.settings.infiniteLoop ? 0 : s.active.index : t;
      };

      return o.goToSlide = function (e, i) {
        var n,
            r,
            a,
            l,
            d = !0,
            c = 0,
            g = {
          left: 0,
          top: 0
        },
            u = null;

        if (s.oldIndex = s.active.index, s.active.index = Q(e), !s.working && s.active.index !== s.oldIndex) {
          if (s.working = !0, void 0 !== (d = s.settings.onSlideBefore.call(o, s.children.eq(s.active.index), s.oldIndex, s.active.index)) && !d) return s.active.index = s.oldIndex, void (s.working = !1);
          "next" === i ? s.settings.onSlideNext.call(o, s.children.eq(s.active.index), s.oldIndex, s.active.index) || (d = !1) : "prev" === i && (s.settings.onSlidePrev.call(o, s.children.eq(s.active.index), s.oldIndex, s.active.index) || (d = !1)), s.active.last = s.active.index >= f() - 1, (s.settings.pager || s.settings.pagerCustom) && z(s.active.index), s.settings.controls && q(), "fade" === s.settings.mode ? (s.settings.adaptiveHeight && s.viewport.height() !== p() && s.viewport.animate({
            height: p()
          }, s.settings.adaptiveHeightSpeed), s.children.filter(":visible").fadeOut(s.settings.speed).css({
            zIndex: 0
          }), s.children.eq(s.active.index).css("zIndex", s.settings.slideZIndex + 1).fadeIn(s.settings.speed, function () {
            t(this).css("zIndex", s.settings.slideZIndex), A();
          })) : (s.settings.adaptiveHeight && s.viewport.height() !== p() && s.viewport.animate({
            height: p()
          }, s.settings.adaptiveHeightSpeed), !s.settings.infiniteLoop && s.carousel && s.active.last ? "horizontal" === s.settings.mode ? (u = s.children.eq(s.children.length - 1), g = u.position(), c = s.viewport.width() - u.outerWidth()) : (n = s.children.length - s.settings.minSlides, g = s.children.eq(n).position()) : s.carousel && s.active.last && "prev" === i ? (r = 1 === s.settings.moveSlides ? s.settings.maxSlides - x() : (f() - 1) * x() - (s.children.length - s.settings.maxSlides), u = o.children(".bx-clone").eq(r), g = u.position()) : "next" === i && 0 === s.active.index ? (g = o.find("> .bx-clone").eq(s.settings.maxSlides).position(), s.active.last = !1) : e >= 0 && (l = e * parseInt(x()), g = s.children.eq(l).position()), void 0 !== g && (a = "horizontal" === s.settings.mode ? -(g.left - c) : -g.top, S(a, "slide", s.settings.speed)), s.working = !1), s.settings.ariaHidden && j(s.active.index * x());
        }
      }, o.goToNextSlide = function () {
        if ((s.settings.infiniteLoop || !s.active.last) && !0 !== s.working) {
          var t = parseInt(s.active.index) + 1;
          o.goToSlide(t, "next");
        }
      }, o.goToPrevSlide = function () {
        if ((s.settings.infiniteLoop || 0 !== s.active.index) && !0 !== s.working) {
          var t = parseInt(s.active.index) - 1;
          o.goToSlide(t, "prev");
        }
      }, o.startAuto = function (t) {
        s.interval || (s.interval = setInterval(function () {
          "next" === s.settings.autoDirection ? o.goToNextSlide() : o.goToPrevSlide();
        }, s.settings.pause), s.settings.onAutoChange.call(o, !0), s.settings.autoControls && !0 !== t && D("stop"));
      }, o.stopAuto = function (t) {
        s.autoPaused && (s.autoPaused = !1), s.interval && (clearInterval(s.interval), s.interval = null, s.settings.onAutoChange.call(o, !1), s.settings.autoControls && !0 !== t && D("start"));
      }, o.getCurrentSlide = function () {
        return s.active.index;
      }, o.getCurrentSlideElement = function () {
        return s.children.eq(s.active.index);
      }, o.getSlideElement = function (t) {
        return s.children.eq(t);
      }, o.getSlideCount = function () {
        return s.children.length;
      }, o.isWorking = function () {
        return s.working;
      }, o.redrawSlider = function () {
        s.children.add(o.find(".bx-clone")).outerWidth(h()), s.viewport.css("height", p()), s.settings.ticker || m(), s.active.last && (s.active.index = f() - 1), s.active.index >= f() && (s.active.last = !0), s.settings.pager && !s.settings.pagerCustom && (w(), z(s.active.index)), s.settings.ariaHidden && j(s.active.index * x());
      }, o.destroySlider = function () {
        s.initialized && (s.initialized = !1, t(".bx-clone", this).remove(), s.children.each(function () {
          void 0 !== t(this).data("origStyle") ? t(this).attr("style", t(this).data("origStyle")) : t(this).removeAttr("style");
        }), void 0 !== t(this).data("origStyle") ? this.attr("style", t(this).data("origStyle")) : t(this).removeAttr("style"), t(this).unwrap().unwrap(), s.controls.el && s.controls.el.remove(), s.controls.next && s.controls.next.remove(), s.controls.prev && s.controls.prev.remove(), s.pagerEl && s.settings.controls && !s.settings.pagerCustom && s.pagerEl.remove(), t(".bx-caption", this).remove(), s.controls.autoEl && s.controls.autoEl.remove(), clearInterval(s.interval), s.settings.responsive && t(window).off("resize", U), s.settings.keyboardEnabled && t(document).off("keydown", B), t(this).removeData("bxSlider"), t(window).off("blur", W).off("focus", H));
      }, o.reloadSlider = function (e) {
        void 0 !== e && (n = e), o.destroySlider(), l(), t(o).data("bxSlider", this);
      }, l(), t(o).data("bxSlider", this), this;
    }
  };
}(jQuery);

},{}],4:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*!
 * Macy.js v2.0.0 - Macy is a lightweight, dependency free, masonry layout library
 * Author: Copyright (c) Big Bite Creative <@bigbitecreative> <http://bigbitecreative.com>
 * Url: http://macyjs.com/
 * License: MIT
 */
!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : t.Macy = e();
}(void 0, function () {
  "use strict";

  function t(t) {
    var e = document.body.clientWidth,
        o = void 0;

    for (var n in t.breakAt) {
      if (e < n) {
        o = t.breakAt[n];
        break;
      }
    }

    return o || (o = t.columns), o;
  }

  function e(e) {
    var o = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
        n = t(e),
        r = void 0,
        i = 100 / n;
    return o ? 1 === n ? "100%" : (r = (n - 1) * e.margin / n, "calc(" + i + "% - " + r + "px)") : i;
  }

  function o(o, n) {
    var r = t(o.options),
        i = 0,
        s = void 0;
    return 1 === ++n ? 0 : (s = (o.options.margin - (r - 1) * o.options.margin / r) * (n - 1), i += e(o.options, !1) * (n - 1), "calc(" + i + "% + " + s + "px)");
  }

  function n(t) {
    for (var e = 0, o = t.container, n = t.rows, r = n.length - 1; r >= 0; r--) {
      e = n[r] > e ? n[r] : e;
    }

    o.style.height = e + "px";
  }

  function r(e, o) {
    var r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
        i = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3];
    l(e, t(e.options), r), o.forEach(function (t) {
      var o = 0,
          n = parseInt(t.offsetHeight, 10);
      isNaN(n) || (e.rows.forEach(function (t, n) {
        t < e.rows[o] && (o = n);
      }), t.style.position = "absolute", t.style.top = e.rows[o] + "px", t.style.left = "" + e.cols[o], e.rows[o] += isNaN(n) ? 0 : n + e.options.margin, i && (t.dataset.macyComplete = 1));
    }), i && (e.tmpRows = null), n(e);
  }

  function i(e, o) {
    var r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
        i = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3],
        s = t(e.options);
    l(e, s, r), o.forEach(function (t) {
      e.lastcol === s && (e.lastcol = 0);
      var o = c(t, "height");
      o = parseInt(o.replace("px", ""), 10), isNaN(o) || (t.style.position = "absolute", t.style.top = e.rows[e.lastcol] + "px", t.style.left = "" + e.cols[e.lastcol], e.rows[e.lastcol] += isNaN(o) ? 0 : o + e.options.margin, e.lastcol += 1, i && (t.dataset.macyComplete = 1));
    }), i && (e.tmpRows = null), n(e);
  }

  function s(t, e) {
    var o = void 0;
    return function () {
      o && clearTimeout(o), o = setTimeout(t, e);
    };
  }

  Object.getOwnPropertyNames(Array.prototype).forEach(function (t) {
    "length" !== t && (NodeList.prototype[t] = Array.prototype[t], HTMLCollection.prototype[t] = Array.prototype[t]);
  });

  var a = function t(e, o) {
    if (!(this instanceof t)) return new t(e, o);
    if (e = e.replace(/^\s*/, "").replace(/\s*$/, ""), o) return this.byCss(e, o);

    for (var n in this.selectors) {
      if (o = n.split("/"), new RegExp(o[1], o[2]).test(e)) return this.selectors[n](e);
    }

    return this.byCss(e);
  };

  a.prototype.byCss = function (t, e) {
    return (e || document).querySelectorAll(t);
  }, a.prototype.selectors = {}, a.prototype.selectors[/^\.[\w\-]+$/] = function (t) {
    return document.getElementsByClassName(t.substring(1));
  }, a.prototype.selectors[/^\w+$/] = function (t) {
    return document.getElementsByTagName(t);
  }, a.prototype.selectors[/^\#[\w\-]+$/] = function (t) {
    return document.getElementById(t.substring(1));
  };

  var c = function c(t, e) {
    return window.getComputedStyle(t, null).getPropertyValue(e);
  },
      l = function l(t, e) {
    var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];

    if (t.lastcol || (t.lastcol = 0), n) {
      t.rows = [], t.cols = [], t.lastcol = 0;

      for (var r = e - 1; r >= 0; r--) {
        t.rows[r] = 0, t.cols[r] = o(t, r);
      }
    }

    if (t.tmpRows) {
      t.rows = [];

      for (var r = e - 1; r >= 0; r--) {
        t.rows[r] = t.tmpRows[r];
      }
    } else {
      t.tmpRows = [];

      for (var r = e - 1; r >= 0; r--) {
        t.tmpRows[r] = t.rows[r];
      }
    }
  },
      u = function u(t) {
    var o = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
        n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2],
        s = o ? t.container.children : a(':scope > *:not([data-macy-complete="1"])', t.container),
        c = e(t.options);
    return s.forEach(function (t) {
      o && (t.dataset.macyComplete = 0), t.style.width = c;
    }), t.options.trueOrder ? i(t, s, o, n) : r(t, s, o, n);
  },
      p = function p(t, e) {
    setTimeout(function () {
      var o = t();
      e && e(o);
    }, 0);
  },
      f = function f(t, e, o) {
    t && p(t), o.req === o.complete && p(e);
  },
      h = function h(t, e, o) {
    var n = t.length,
        r = 0;
    t.forEach(function (t) {
      t.complete && (r++, f(e, o, {
        req: n,
        complete: r
      })), t.addEventListener("load", function () {
        r++, f(e, o, {
          req: n,
          complete: r
        });
      });
    });
  },
      d = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var o = arguments[e];

      for (var n in o) {
        Object.prototype.hasOwnProperty.call(o, n) && (t[n] = o[n]);
      }
    }

    return t;
  },
      m = {
    columns: 4,
    margin: 2,
    trueOrder: !0,
    waitForImages: !1
  },
      v = function t() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : m;
    if (!(this instanceof t)) return new t(e);
    if (this.options = {}, d(this.options, m, e), this.container = a(e.container), this.container instanceof a || !this.container) return !!e.debug && console.error("Error: Container not found");
    delete this.options.container, this.container.length && (this.container = this.container[0]), this.container.style.position = "relative", this.rows = [];
    var o = this.recalculate.bind(this, !1, !1),
        n = this.recalculate.bind(this, !0, !0),
        r = a("img", this.container);
    if (this.resizer = s(function () {
      n();
    }, 100), window.addEventListener("resize", this.resizer), e.waitForImages) return h(r, null, n);
    this.recalculate(!0, !1), h(r, o, n);
  };

  return v.init = function (t) {
    return console.warn("Depreciated: Macy.init will be removed in v3.0.0 opt to use Macy directly like so Macy({ /*options here*/ }) "), new v(t);
  }, v.prototype.recalculateOnImageLoad = function () {
    var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
        e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
        o = a("img", this.container),
        n = this.recalculate.bind(this, e, !1),
        r = this.recalculate.bind(this, e, !0);
    return t ? h(o, null, r) : (n(), h(o, n, r));
  }, v.prototype.runOnImageLoad = function (t) {
    var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
        o = a("img", this.container);
    return e ? h(o, t, t) : h(o, null, t);
  }, v.prototype.recalculate = function () {
    return u(this, arguments.length > 0 && void 0 !== arguments[0] && arguments[0], !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1]);
  }, v.prototype.remove = function () {
    window.removeEventListener("resize", this.resizer), this.container.children.forEach(function (t) {
      t.removeAttribute("data-macy-complete"), t.removeAttribute("style");
    }), this.container.removeAttribute("style");
  }, v.prototype.reInit = function () {
    this.recalculate(!0, !0), window.addEventListener("resize", this.resizer);
  }, v;
});

},{}]},{},[2]);
